import { useRouter } from 'expo-router';
import { ICartEntry } from 'features/cart/types';
import { Typography } from 'ucl';

import { appendObjectToQueryString, convertQueryStringToObject } from 'navigation/utils';
import { t } from 'state/intl/translations';

import { cartActionsStyles } from './cart-actions-styles';
import { CartEntryActionButton } from './cart-entry-action-button';

export const CartEntryEditButton = ({
  cartEntry,
  disabled,
}: {
  cartEntry: ICartEntry;
  disabled?: boolean;
}) => {
  const router = useRouter();

  const handleEdit = () => {
    const baseUrl = cartEntry.url.split('?')[0];

    // This is to support offer pickers editing
    const queryParams = convertQueryStringToObject<{ offerId?: string; rewardId?: string }>(
      cartEntry.url.replace(`${baseUrl}?`, '')
    );
    const offerIdParam = queryParams.offerId;
    const rewardIdParam = queryParams.rewardId;

    const productWizardEditUrl = appendObjectToQueryString(baseUrl, {
      isEdit: true,
      cartIdEditing: cartEntry.cartId,
      isFromCart: true,
      isProductReviewFromCart: true,
      ...(offerIdParam ? { offerId: offerIdParam } : {}),
      ...(rewardIdParam ? { rewardId: rewardIdParam } : {}),
    });

    // TODO modify it  for oneMenu
    // const attributes = {
    //   'Product Id': cartEntry.id,
    //   'Product Name': cartEntry.name,
    //   'Edit Url': productWizardEditUrl,
    //   'Is Reorder': booleanToString(false),
    //   'Is Offer': booleanToString(isOfferCartEntry(cartEntry)),
    // };
    // logRBIProductsDetailsEvent({
    //   name: CustomEventNames.EDIT_CART,
    //   products: [cartEntry as ICartEntryLoggable],
    //   attributes,
    // });

    router.push(productWizardEditUrl);
  };

  return (
    <CartEntryActionButton
      disabled={disabled}
      accessibilityLabel={`${t('edit')} ${cartEntry.name} `}
      testID="edit-cart-entry-button"
      onPress={handleEdit}
    >
      <Typography style={cartActionsStyles.removeText}>{t('edit')}</Typography>
    </CartEntryActionButton>
  );
};
